import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import logo from "../photo/logo.png";
import panier from "../photo/panier.png";
import login from "../photo/login.png";
import { useSelector } from "react-redux";
import { LogOut, LogIn, Menu, X, Heart, History, Settings, ClipboardList, User as UserIcon, ChevronDown, Shield } from "lucide-react";
import { UserProfileModal } from "./userProfileModal";
import "../styles/navbar.css";

export function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const listC = useSelector(s => s.listC) || [];
    const listP = useSelector(s => s.listP) || [];
    const loggedUser = localStorage.getItem('user');
    const userObj = loggedUser ? JSON.parse(loggedUser) : null;
    const userEmail = userObj?.email || null;
    const panierItems = (useSelector(s => s.panier) || []).filter(p => p.userEmail === userEmail);
    const navigate = useNavigate();

    const getUniqueGenres = (list, type) => {
        if (!list || !Array.isArray(list)) return [];
        const genres = [];
        for (let i = 0; i < list.length; i++) {
            const genre = type === 'climatisseurs' ? list[i].markClimatisseur : list[i].ville;
            if (genre && !genres.includes(genre)) {
                genres.push(genre);
            }
        }
        return genres;
    };

    const handleLogout = () => {
        if (window.confirm("Voulez-vous vous déconnecter ?")) {
            localStorage.removeItem('user');
            navigate("/login");
            setUserDropdownOpen(false);
        }
    };

    const genresClimatisseurs = getUniqueGenres(listC, 'climatisseurs');
    const villesProjets = getUniqueGenres(listP, 'projets');

    return (
        <nav className="main-navbar">
            <div className="nav-left">
                <Link to="/" onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}>
                    <img src={logo} alt="JL Logo" className="nav-logo" />
                </Link>
            </div>

            <div className={`nav-center ${menuOpen ? 'mobile-open' : ''}`}>
                <div className="nav-item-container">
                    <span className="nav-item-label climatiseurs">Climatiseurs</span>
                    <div className="nav-dropdown-menu">
                        {genresClimatisseurs.length > 0 ? (
                            genresClimatisseurs.map((genre, index) => (
                                <Link
                                    key={index}
                                    to={`/categorieClimatisseurs/${genre}`}
                                    className="dropdown-item"
                                    onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}
                                >
                                    Climatiseurs {genre}
                                </Link>
                            ))
                        ) : (
                            <span className="dropdown-item">Aucun genre trouvé</span>
                        )}
                    </div>
                </div>

                <div className="nav-item-container">
                    <span className="nav-item-label projets">Projets</span>
                    <div className="nav-dropdown-menu">
                        {villesProjets.length > 0 ? (
                            villesProjets.map((ville, index) => (
                                <Link
                                    key={index}
                                    to={`/categorieProjets/${ville}`}
                                    className="dropdown-item"
                                    onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}
                                >
                                    {ville}
                                </Link>
                            ))
                        ) : (
                            <span className="dropdown-item">Aucun projet trouvé</span>
                        )}
                    </div>
                </div>
            </div>

            <div className="nav-right">
                <Link to="/panier" className="cart-link" onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}>
                    <img src={panier} alt="Cart" className="cart-img" />
                    {panierItems.length > 0 && (
                        <span className="cart-badge">{panierItems.length}</span>
                    )}
                </Link>

                {loggedUser ? (
                    <div className="user-profile-section">
                        {userObj.role === 'admin' ? (
                            <Link to="/dashbordPage" className="admin-direct-link" title="Dashboard Admin">
                                <Shield size={22} color="#700000" />
                                <span className="admin-nav-text">Dashboard</span>
                            </Link>
                        ) : (
                            <>
                                <button 
                                    className={`user-nav-toggle ${userDropdownOpen ? 'active' : ''}`}
                                    onClick={() => setUserDropdownOpen(true)}
                                >
                                    <div className="avatar-small-container">
                                        {userObj.profilePic ? (
                                            <img src={userObj.profilePic} alt="Me" className="user-nav-avatar" />
                                        ) : (
                                            <span className="user-initial">
                                                {userObj.name ? userObj.name.charAt(0).toUpperCase() : userObj.email.charAt(0).toUpperCase()}
                                            </span>
                                        )}
                                    </div>
                                    <span className="user-nav-name">{userObj.name || userObj.email.split('@')[0]}</span>
                                    <ChevronDown size={16} className={`chevron-icon ${userDropdownOpen ? 'rotate' : ''}`} />
                                </button>

                                <UserProfileModal 
                                    isOpen={userDropdownOpen} 
                                    onClose={() => setUserDropdownOpen(false)} 
                                />
                            </>
                        )}
                    </div>
                ) : (
                    <Link to="/login" className="user-actions" title="Se connecter" onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}>
                        <LogIn size={28} color="#000033" />
                    </Link>
                )}

                <button className="menu-toggle" onClick={() => { setMenuOpen(!menuOpen); setUserDropdownOpen(false); }}>
                    {menuOpen ? <X size={28} color="#000033" /> : <Menu size={28} color="#000033" />}
                </button>
            </div>
        </nav>
    );
}
